/**
 * @generated SignedSource<<7b2db83864378fbe8fcdf752afba5c30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubblesWrapper_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbles_item" | "PdpRespTradeIconBubbles_item">;
  readonly " $fragmentType": "PdpRespIconBubblesWrapper_item";
};
export type PdpRespIconBubblesWrapper_item$key = {
  readonly " $data"?: PdpRespIconBubblesWrapper_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubblesWrapper_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubblesWrapper_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_item"
    },
    {
      "condition": "isTrade",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespTradeIconBubbles_item"
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "f772fc672a6929d8b888ed1950bbfa1e";

export default node;
